export default __webpack_public_path__ + "static/media/ck.aeaca035.svg";